/*************************************************/
/* LANGUAGE                                      */
/*************************************************/

export function language() {
    const languageSelectorSelector = ".language-selector";
    const visibleClass = "language-selector--visible";

    const toggleLanguageSelector = function (languageSelector, forceClose = false) {
        if (languageSelector != null) {
            if (forceClose) {
                languageSelector.classList.remove(visibleClass);
            } else if (!languageSelector.classList.contains(visibleClass)) {
                languageSelector.classList.add(visibleClass);
            } else {
                languageSelector.classList.remove(visibleClass);
            }
        }
    }

    const init = function () {
        const languageSelectors = document.querySelectorAll(languageSelectorSelector);
        if (!languageSelectors.length) return;

        languageSelectors.forEach(selector => {
            selector.querySelector('.language-selector__current').addEventListener('click', e => {
                toggleLanguageSelector(e.target.closest(languageSelectorSelector));
            });
        });

        document.addEventListener('click', e => {
            if (e.target.closest(languageSelectorSelector)) return;
            languageSelectors.forEach(selector => toggleLanguageSelector(selector, true));
        });
    };

    init();
}

